import { Button } from "reactstrap";
import { EmailIcon } from "../../constants/icons";
import "./Button.css";

const EmailButton = (props) => {
  const syncing = !!props.syncing;
  return (
    <span
      className={`bomButtonsWrap${syncing ? " is-disabled" : ""}`}
      onMouseEnter={syncing ? props.onSyncingHover : undefined}
    >
      <Button
        className="bomButtons linkBtn email"
        type="button"
        disabled={syncing}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          if (syncing || !props.onClick) {
            return;
          }
          props.onClick(event);
        }}
      >
        <EmailIcon className="icon" />
        <div className="text">Share via Email</div>
      </Button>
    </span>
  );
};

export default EmailButton;
